<template>
  <b-form>
    <div id="fulfillment-information">
      <div class="modal-wrp mx-1rem">
        <div class="row">
          <div class="col-12">
            <div class="information-header text-bold mb-2">
              {{ "Information" }}
            </div>
            <div class="row">
              <div class="col-lg-6 col-sm-12 col-xs-12">
                <div class="row">
                  <div class="col-lg-12 col-sm-12 col-xs-12">
                    <b-form-group
                      :label="'Transaction Reference.'"
                      label-for="reftran"
                      label-class="font-medium-5"
                    >
                      <b-form-input
                        id="refIssue"
                        v-model="formData.tranRef"
                        disabled
                      />
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12 col-sm-12 col-xs-12">
                    <b-form-group
                      :label="'Reward Ref.'"
                      label-for="refReward"
                      label-class="font-medium-5"
                    >
                      <b-form-input
                        id="refReward"
                        v-model="formData.rewardRef"
                        disabled
                      />
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12 col-sm-12 col-xs-12">
                    <b-form-group
                      :label="'Reward'"
                      label-for="reward"
                      label-class="font-medium-5"
                    >
                      <b-form-input
                        id="reward"
                        v-model="formData.reward"
                        disabled
                      />
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12 col-sm-12 col-xs-12">
                    <b-form-group v-if="formData.status == 1"
                      :label="'Status'"
                      label-for="status"
                      label-class="font-medium-5"
                    >
                      <b-form-input
                        id="status"
                        value="Active"
                        disabled
                      />
                    </b-form-group>
                     <b-form-group  v-if="formData.status == 9"
                      :label="'Status'"
                      label-for="status"
                      label-class="font-medium-5"
                    >
                      <b-form-input
                        id="status"
                        value="Void"
                        disabled
                      />
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12 col-sm-12 col-xs-12">
                    <b-form-group
                      :label="'Qty.'"
                      label-for="qty"
                      label-class="font-medium-5"
                    >
                      <b-form-input id="qty" v-model="formData.qty" disabled />
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12 col-sm-12 col-xs-12">
                    <b-form-group
                      :label="'Point/Total'"
                      label-for="pointTotal"
                      label-class="font-medium-5"
                    >
                      <b-form-input
                        id="pointTotal"
                        v-model="formData.pointTotal"
                        disabled
                      />
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12 col-sm-12 col-xs-12">
                    <b-form-group
                      :label="'Reward Value'"
                      label-for="rewardValue"
                      label-class="font-medium-5"
                    >
                      <b-form-input
                        id="rewardValue"
                        v-model="formData.rewardValue"
                        disabled
                      />
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12 col-sm-12 col-xs-12">
                    <b-form-group
                      :label="'Issue Date'"
                      label-for="issueDate"
                      label-class="font-medium-5"
                    >
                      <b-form-input
                        id="issueDate"
                        v-model="formData.issueDate"
                        disabled
                      />
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12 col-sm-12 col-xs-12">
                    <b-form-group
                      :label="'Voided Date'"
                      label-for="voidedDate"
                      label-class="font-medium-5"
                    >
                      <b-form-input
                        id="voidedDate"
                        v-model="formData.VoidedDate"
                        disabled
                      />
                    </b-form-group>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-sm-12 col-xs-12">
                <div class="row">
                  <div class="col-lg-12 col-sm-12 col-xs-12">
                    <b-form-group
                      :label="'Tx_ref'"
                      label-for="txRef"
                      label-class="font-medium-5"
                    >
                      <b-form-input
                        id="txRef"
                        v-model="formData.txRef"
                        disabled
                      />
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12 col-sm-12 col-xs-12">
                    <b-form-group
                      :label="'Remark'"
                      label-for="remark"
                      label-class="font-medium-5"
                    >
                      <b-form-input
                        id="remark"
                        v-model="formData.remarkInfo"
                        disabled
                      />
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12 col-sm-12 col-xs-12">
                    <b-form-group
                      :label="'Void_ref'"
                      label-for="voidRef"
                      label-class="font-medium-5"
                    >
                      <b-form-input
                        id="voidRef"
                        v-model="formData.voidRef"
                        disabled
                      />
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12 col-sm-12 col-xs-12">
                    <b-form-group
                      :label="'Void_remark'"
                      label-for="voidRemark"
                      label-class="font-medium-5"
                    >
                      <b-form-input
                        id="voidRemark"
                        v-model="formData.voidRemark"
                        disabled
                      />
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12 col-sm-12 col-xs-12">
                    <b-form-group
                      :label="'Itf_ref'"
                      label-for="itfRef"
                      label-class="font-medium-5"
                    >
                      <b-form-input
                        id="itfRef"
                        v-model="formData.itfRef"
                        disabled
                      />
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12 col-sm-12 col-xs-12">
                    <b-form-group
                      :label="'Itf_ref_2'"
                      label-for="itfRef2"
                      label-class="font-medium-5"
                    >
                      <b-form-input
                        id="itfRef2"
                        v-model="formData.itfRef2"
                        disabled
                      />
                    </b-form-group>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-form>
</template>

<script>

export default {
  props: {formData : {type: Object , default: {}} },
  setup() {
    

    return {
     
    };
  },
};
</script>

<style>
@import "~@/assets/css/pages/fulfillment/fulfillment-modal.css";
</style>